import {PaperDto, UserDto} from '../../scaffold';

export default function PaperKeywordFilter(paper: PaperDto, keyword: string) {
  return (paper.name || '').includes(keyword);
}
